// Константы
import { EXCEL_STYLES, DEFAULT_LOGO } from './constants.js';

// Утилиты
import { hexToBackgroundAttributes, hexToForegroundAttributes } from './utils/colors.js';
import { safeFileName } from './utils/files.js';
import { sortColumnsByOrder } from './utils/columns.js';

// Данные
import { detectDataFormat } from './data/format-detector.js';
import { calculateAggregationFromData } from './data/aggregation.js';

// Основной класс
import { ExcelExporter } from './exporter-core.js';

// Фабричные функции
const createExporter = (options = {}) => new ExcelExporter(options);

const exportToExcel = async (exportData, options = {}, fileExtension = null) => {
  const exporter = new ExcelExporter(options);
  return await exporter.exportToExcel(exportData, fileExtension);
};

export default {
  createExporter,
  exportToExcel,
  calculateAggregationFromData,
  sortColumnsByOrder,
  hexToBackgroundAttributes,
  hexToForegroundAttributes,
  safeFileName,
  detectDataFormat,
  EXCEL_STYLES,
  DEFAULT_LOGO
};